import { STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'

import { beRecipientApiUpdateRecipientContacts } from 'Api/beRecipientApiTS'
import type { RecipientContactsOut } from 'Types/beRecipientsApi'

export const updateContacts = async (
  idRecipient: number,
  {
    Email,
    MobilePrefix,
    MobileNumber,
    EmailDisabled,
    SMSDisabled,
  }: {
    Email: string
    MobilePrefix: string
    MobileNumber: string
    EmailDisabled: boolean
    SMSDisabled: boolean
  },
): Promise<RecipientContactsOut['Result']> => {
  const idList: number = storeGet(STORE_KEY_ID_LIST)
  const payload = {
    Email: EmailDisabled ? undefined : Email,
    MobilePrefix: SMSDisabled ? undefined : MobilePrefix,
    MobileNumber: SMSDisabled ? undefined : MobileNumber,
  }

  const { Result } = await beRecipientApiUpdateRecipientContacts(
    idList,
    idRecipient,
    payload,
  )

  return Result
}
